// extracted by mini-css-extract-plugin
export var heroImage = "_k2-1";
export var modal = "_k2-0";